import { describeStaleReferencesForToast } from '@/lib/masterReferenceStaleness';

// The refusal's own reason, as a sentence for the note beside the button. A
// staleness refusal names what blocked it (since the exemption, a stale
// header - the lines are no longer a reason); anything else says what the
// server said.
export const describeRegenerateRefusal = (outcome, totalLines = null) => {
  const detail = outcome?.error?.response?.data?.detail;
  if (detail && typeof detail === 'object' && detail.code === 'MASTER_REFERENCE_STALE'
    && Array.isArray(detail.stale_references) && detail.stale_references.length) {
    return `${describeStaleReferencesForToast(detail.stale_references, totalLines)} Then try again.`;
  }
  if (detail && typeof detail === 'object' && detail.message) return detail.message;
  if (typeof detail === 'string') return detail;
  return outcome?.message || 'The regeneration failed. Please try again.';
};
